/* tslint:disable */
/* eslint-disable */
/**
 * residents
 * residents
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProgressNotesListEntry } from './ProgressNotesListEntry';
import {
    ProgressNotesListEntryFromJSON,
    ProgressNotesListEntryFromJSONTyped,
    ProgressNotesListEntryToJSON,
} from './ProgressNotesListEntry';

/**
 * 
 * @export
 * @interface ProgressNotesFindAllResponse
 */
export interface ProgressNotesFindAllResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ProgressNotesFindAllResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProgressNotesFindAllResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ProgressNotesFindAllResponse
     */
    count: number;
    /**
     * 
     * @type {Array<ProgressNotesListEntry>}
     * @memberof ProgressNotesFindAllResponse
     */
    rows: Array<ProgressNotesListEntry>;
}

/**
 * Check if a given object implements the ProgressNotesFindAllResponse interface.
 */
export function instanceOfProgressNotesFindAllResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "rows" in value;

    return isInstance;
}

export function ProgressNotesFindAllResponseFromJSON(json: any): ProgressNotesFindAllResponse {
    return ProgressNotesFindAllResponseFromJSONTyped(json, false);
}

export function ProgressNotesFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgressNotesFindAllResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'count': json['count'],
        'rows': ((json['rows'] as Array<any>).map(ProgressNotesListEntryFromJSON)),
    };
}

export function ProgressNotesFindAllResponseToJSON(value?: ProgressNotesFindAllResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hasNextPage': value.hasNextPage,
        'page': value.page,
        'count': value.count,
        'rows': ((value.rows as Array<any>).map(ProgressNotesListEntryToJSON)),
    };
}

